export enum Pais {
  "Mexico" = "mx",
  "EstadosUnidos" = "us",
}
